import { useSyncExternalStore } from "react";
import {
  type ApiAvailability,
  getApiAvailability,
  subscribeApiAvailability,
} from "./api-availability";

export function useApiAvailability(): ApiAvailability {
  return useSyncExternalStore(
    subscribeApiAvailability,
    getApiAvailability,
    getApiAvailability,
  );
}
